import { render, staticRenderFns } from "./PromotionDetails.vue?vue&type=template&id=7cb1ed2e"
import script from "./PromotionDetails.vue?vue&type=script&lang=js"
export * from "./PromotionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports